// The scene page's "More from {series}" block. A series is the release's
// sponsor; `/api/sponsors/:slug` lists its scenes on the current site.

// A series needs this many other tour-visible scenes on the site to get a
// block, so cross-posted strays (passion-hd has 9 Baeb scenes) don't.
export const SERIES_BLOCK_MIN_OTHERS = 10

const normalize = (value) =>
  (value ?? "").toLowerCase().replace(/[^a-z0-9]/g, "")

// True when the sponsor is the site's own brand ("Damn Thats Big" and
// "DamnThatsBig", "ExGF" on exgfpass). A block for it would only repeat the
// site, whose own scenes are everywhere else on the tour.
export const isSiteOwnSponsor = (site, sponsor) => {
  const sponsorName = normalize(sponsor?.name)
  if (!sponsorName) return false

  const siteName = normalize(site?.name)
  const siteSlug = normalize(site?.slug)

  return (
    sponsorName === siteName ||
    sponsorName === siteSlug ||
    siteSlug.startsWith(sponsorName)
  )
}

// Whether a scene's sponsor may get a block, before counting its scenes.
// `exclusiveOnly` is pornplus, which only links its exclusive series, as its
// release cards do.
export const seriesBlockCandidate = (site, sponsor, { exclusiveOnly }) =>
  Boolean(sponsor?.cachedSlug) &&
  !isSiteOwnSponsor(site, sponsor) &&
  (!exclusiveOnly || Boolean(sponsor.exclusive))

// The series hub. Networks with sub-sites list them at /sites; everyone else
// at /series. Both routes render the same data, and the other one points its
// canonical here.
export const seriesHubPath = (slug, { hasSubSites }) =>
  `/${hasSubSites ? "sites" : "series"}/${encodeURIComponent(slug)}`
